import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, Grid } from "@material-ui/core";
import { getMessages } from "../../../store/constructs/messages/selectors";
import { checkNameExist } from "../bluePrintComponents/SystemModel/helpers";
import { useForm } from "react-hook-form";
import { basic, validationMessages } from '../../../config/validations';
import { makeStyles } from '@material-ui/core/styles';
import { handleSnackBar, setReRender } from '../../../store/global/actions';
import { invokePostService, invokeGetService, setInnerScreenRender } from "../../../store/global/actions";



const useStyles = makeStyles({
    button: {
        height: 53,
        marginLeft: 10
    }
})

export default function RenameEventType({ event, item, setNewMessage }) {
    // console.log('prop for msg-------->', event)

    const classes = useStyles();
    const dispatch = useDispatch();

    let msgId = '';

    if (event?.item != undefined) msgId = event?.item.message;
    if (event?._id != undefined) msgId = event?._id


    const storeMessages = useSelector(getMessages)
    const [message, setMessage] = useState(item)
    const [isUpdating, setIsUpdating] = useState(false);

    const { register, handleSubmit, formState: { errors }, reset, setError } = useForm({
        defaultValues: {
            name: message?.name || ""
        }
    });
    const messages = {
        ...validationMessages,
        validate: 'Message with the given name exists'
    }

    useEffect(() => {
        dispatch(invokeGetService('getMessageData', [msgId]))
            .then((response) => {
                if (response.status) {
                    setMessage(response.data.msg)
                }
            })
    }, [event])

    useEffect(() => {
        reset({
            name: message ? message.name : ''
        })
    }, [message])

    const nameExist = (name) => {
        const filteredMessages = storeMessages.filter(msg => msg.id !== message.id)
        const status = checkNameExist(name, filteredMessages)
        return status === true ? false : true
    }


    const onSave = (data) => {

        setIsUpdating(true)

        // const selectedMessage = storeMessages.find(item => item.id === message.id)
        // if (selectedMessage && selectedMessage.fields) delete selectedMessage.fields;

        const editedMessage = {
            ...message,
            name: data.name
        }
        // dispatch(editMessage(editedMessage));
        // 
        dispatch(invokePostService('updateMessage', { messageData: editedMessage }, [message._id]))
            .then(savedData => {
                if (savedData.status) {
                    if (setNewMessage != undefined) setNewMessage({...editedMessage})
                    setIsUpdating(false);
                    dispatch(setReRender());
                    dispatch(setInnerScreenRender())
                    dispatch(handleSnackBar({ open: true, message: `Event type updated`, severity: "success" }));
                }
                else {
                    if (savedData?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, { message: error.message });
                        });
                    }
                    setIsUpdating(false);
                }

            })
            .catch((error) => {

                console.error(error)
                setIsUpdating(false);
                dispatch(handleSnackBar({ open: true, message: `Error on updating Event type`, severity: "error" }));
            });
    }
    return (
        <>
            {
                message && 
                <Grid id={"edit_message_form"} container direction={"row"} spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            name="name"
                            label={"Name"}
                            fullWidth
                            type={"text"}
                            required
                            variant="outlined"
                            inputRef={register({ ...basic })}
                            error={errors?.name ? true : false}
                            // helperText={messages[errors?.name?.type] || ''}
                            helperText={errors?.name ? errors.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                            id="edit_msg_input"
                        />
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button onClick={handleSubmit(onSave)} color="primary" variant="contained" className={classes.button} disabled={isUpdating} id="update_msg_btn">
                            {isUpdating ? 'Updating..' : 'Update'}
                        </Button>
                    </Grid>
                </Grid>
            }
        </>
    )
}